import React from 'react';
import Image from '../../assets/img/MAYSTRODONS.svg'

const AboutImage = () => {
    return (
        <div className="about-section__img">
            <img src={Image} alt=""/>
        </div>
    );
};

export default AboutImage;
